import { handleRequests } from '@/helpers';

export const BrandsMixin = {
    methods: {
        async $_brandsMixin_getBrands() {
            this.$_handleLoaderState(true);
            const api = '/api/brands';
            const response = await handleRequests(api);
            let brandList = [];
            if (response.data !== null && response.data.length > 0) {
                brandList = response.data;
            }
            this.$_handleLoaderState(false);
            return brandList;
        }
    }
};
